// 导入必要的React hooks和样式文件
import { useContext, useState, useEffect } from 'react';
import './EditStyle.less';
import { EditContext } from '@/context/EditContext';
import { projectController } from '@/api/edit';
import Icon from '@/components/iconfont/Icon';
import ColorTool from '@/components/colortool/ColorTool';
import CustomRange from '@/components/customrange/CustomRange';
import { useTranslation } from 'react-i18next';
import { Switch } from '@radix-ui/themes';
import select from '@/assets/select.png';
// 字体大小选项列表
const fontSizeList = [
  {
    value: 32,
  },
  {
    value: 36,
  },
  {
    value: 40,
  },
  {
    value: 44,
  },
  {
    value: 48,
  },
  {
    value: 52,
  },
  {
    value: 56,
  },
  {
    value: 64,
  },
  {
    value: 72,
  },
  {
    value: 80,
  },
];

export default function EditStyle() {
  const { t } = useTranslation();
  const { setShowEditCaptions, subtitleShow } = useContext(EditContext);
  // 返回按钮处理函数
  const handleBackCaptions = () => {
    setShowEditCaptions(false);
  };

  return (
    <div className="edit_captions_box">
      {/* 顶部返回栏 */}
      <div className="back_box">
        <Icon name="icon-arrow-left" className="back_icon" onClick={handleBackCaptions} />
        <span>{t('As_Edit_Styleoption1')}</span>
      </div>
      {subtitleShow === 3 && <div className="title_text">{t('As_Edit_StyleDualOriginal334')}</div>}
      {(subtitleShow === 0 || subtitleShow === 1) && (
        <div className="title_text">{t('As_Edit_StyleFont334')}</div>
      )}
      {subtitleShow !== 2 && <OriginalStyle />}
      {subtitleShow === 3 && <div className="title_text">{t('As_Edit_StyleDualTarget334')}</div>}
      {subtitleShow === 2 && <div className="title_text">{t('As_Edit_StyleFont334')}</div>}
      {(subtitleShow === 3 || subtitleShow === 2) && <BilingualStyle />}
    </div>
  );
}

function OriginalStyle() {
  const { t } = useTranslation();
  // 从EditContext获取setShowEditCaptions方法
  const {
    sessionId,
    presetData,
    captionsItem,
    setCaptionsItem,
    newcaptionsItem,
    subtitleShow,
    projectDetail,
    setProjectDetail,
    fontSizeBox,
    doubleFontSizeBox,
    selectedAspectRatio,
    setFontSizeBox,
    setDoubleFontSizeBox,
  } = useContext(EditContext);

  // 字幕编辑详情状态
  const [editCaptionsDetail, setEditCaptionsDetail] = useState({});
  useEffect(() => {
    setEditCaptionsDetail({ ...captionsItem });
  }, [captionsItem]);

  // 颜色选择器显示状态
  const [subtitleColorFlag, setSubtitleColorFlag] = useState(false);
  const [borderColorFlag, setBorderColorFlag] = useState(false);
  const [ShadowColorFlag, setShadowColorFlag] = useState(false);
  const [backgroundColorFlag, setBackgroundColorFlag] = useState(false);

  const [showSelectFamily, setShowSelectFamily] = useState(false);
  const [showSelectFontsize, setShowSelectFontsize] = useState(false);

  const [useFontFamily, setUseFontFamily] = useState({});
  const [useFontSize, setUseFontSize] = useState(0);

  // 字体列表

  const [famylyList, setFamilyList] = useState([]);

  useEffect(() => {
    if (useFontFamily?.fontFamilyUrl) {
      const styleSheet = document.createElement('style');
      styleSheet.textContent = `
          @font-face {
            font-family: 'originalselectdiyfamily';
            src: url('${useFontFamily.fontFamilyUrl}') format('truetype');
          }
        `;
      document.head.appendChild(styleSheet);
      return () => {
        document.head.removeChild(styleSheet);
      };
    }
  }, [useFontFamily?.fontFamilyUrl]);
  useEffect(() => {
    setFamilyList(presetData?.subtitleMenu);
  }, [presetData?.subtitleMenu]);
  useEffect(() => {
    const font = famylyList.filter(
      (item) => item.fontFamilyUrl === editCaptionsDetail?.fontFamilyUrl,
    )[0];
    setUseFontFamily(font);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editCaptionsDetail?.fontFamilyUrl]);

  useEffect(() => {
    let size = 0;
    if (selectedAspectRatio === 0) {
      size = subtitleShow === 3 ? doubleFontSizeBox.originalFontSize169 : fontSizeBox?.fontSize169;
    }
    if (selectedAspectRatio === 1) {
      size = subtitleShow === 3 ? doubleFontSizeBox.originalFontSize11 : fontSizeBox?.fontSize11;
    }
    if (selectedAspectRatio === 2) {
      size = subtitleShow === 3 ? doubleFontSizeBox.originalFontSize916 : fontSizeBox?.fontSize916;
    }
    if (selectedAspectRatio === 3) {
      size = subtitleShow === 3 ? doubleFontSizeBox.originalFontSizeCtm : fontSizeBox?.fontSizeCtm;
    }
    setUseFontSize(size);
    // setEditCaptionsDetail((prve) => ({
    //   ...prve,
    //   fontSize: size,
    // }));
  }, [fontSizeBox, selectedAspectRatio, subtitleShow]);
  // 全局点击事件监听
  useEffect(() => {
    const handleClickOutside = (event) => {
      // 点击字体选择框以外的区域时关闭下拉列表
      const selectFamily = document.querySelector('.original_select_family');
      if (selectFamily && !selectFamily.contains(event.target)) {
        setShowSelectFamily(false);
      }
      const selectFontsize = document.querySelector('.original_select_fontsize');
      if (selectFontsize && !selectFontsize.contains(event.target)) {
        setShowSelectFontsize(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // 文字轮廓开关处理函数
  const handleChangeTextOutline = (e) => {
    editCaptionsDetail.showOutline = e;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      showOutline: e,
    }));
  };

  // 文字阴影开关处理函数
  const handleChangeTextShadow = (e) => {
    editCaptionsDetail.showShadow = e;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      showShadow: e,
    }));
  };

  // 背景开关处理函数
  const handleChangeBackground = (e) => {
    editCaptionsDetail.showBgColor = e;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      showBgColor: e,
    }));
  };

  // 字幕颜色相关处理函数
  const handleChangeSubtitleColor = (val) => {
    editCaptionsDetail.fontColor = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      fontColor: val,
    }));
  };
  const handleChangeSubtitleOpacity = (val) => {
    editCaptionsDetail.fontOpacity = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      fontOpacity: val,
    }));
  };

  // 边框颜色相关处理函数
  const handleChangeBorderColor = (val) => {
    editCaptionsDetail.outlineColor = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      outlineColor: val,
    }));
  };
  const handleChangeBorderOpacity = (val) => {
    editCaptionsDetail.outlineOpacity = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      outlineOpacity: val,
    }));
  };

  // 阴影颜色相关处理函数
  const handleChangeShadowColor = (val) => {
    editCaptionsDetail.shadowColor = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      shadowColor: val,
    }));
  };
  const handleChangeShadowOpacity = (val) => {
    editCaptionsDetail.shadowOpacity = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      shadowOpacity: val,
    }));
  };

  // 背景颜色相关处理函数
  const handleChangeBackgroundColor = (val) => {
    editCaptionsDetail.rectBgColor = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      rectBgColor: val,
    }));
  };
  const handleChangeBackgroundOpacity = (val) => {
    editCaptionsDetail.rectBgOpacity = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      rectBgOpacity: val,
    }));
  };

  const handleChangeFamily = (val) => {
    editCaptionsDetail.fontFamilyUrl = val.fontFamilyUrl;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      fontFamilyUrl: val.fontFamilyUrl,
    }));
  };
  const handleChangeFontSize = (val) => {
    editCaptionsDetail.fontSize = val.value;
    setEditCaptionsDetail((prve) => ({
      ...prve,
      fontSize: val.value,
    }));
    setUseFontSize(val.value);
    let obj = {};
    if (subtitleShow === 3) {
      obj = {
        doubleFontSize: {
          originalFontSize: val.value,
        },
      };
      if (selectedAspectRatio === 0) {
        setDoubleFontSizeBox((prve) => ({
          ...prve,
          originalFontSize169: val.value,
        }));
      }
      if (selectedAspectRatio === 1) {
        setDoubleFontSizeBox((prve) => ({
          ...prve,
          originalFontSize11: val.value,
        }));
      }
      if (selectedAspectRatio === 2) {
        setDoubleFontSizeBox((prve) => ({
          ...prve,
          originalFontSize916: val.value,
        }));
      }
      if (selectedAspectRatio === 3) {
        setDoubleFontSizeBox((prve) => ({
          ...prve,
          originalFontSizeCtm: val.value,
        }));
      }
    } else {
      obj = {
        fontSize: {
          originalFontSize: val.value,
        },
      };
      if (selectedAspectRatio === 0) {
        setFontSizeBox((prve) => ({
          ...prve,
          fontSize169: val.value,
        }));
      }
      if (selectedAspectRatio === 1) {
        setFontSizeBox((prve) => ({
          ...prve,
          fontSize11: val.value,
        }));
      }
      if (selectedAspectRatio === 2) {
        setFontSizeBox((prve) => ({
          ...prve,
          fontSize916: val.value,
        }));
      }
      if (selectedAspectRatio === 3) {
        setFontSizeBox((prve) => ({
          ...prve,
          fontSizeCtm: val.value,
        }));
      }
    }
    setCaptionsItem(editCaptionsDetail);
    try {
      const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
      projectController.updateFontSize({
        projectId: projectItem.id,
        body: {
          sessionId,
          ...obj,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleToggleFontBold = () => {
    const fontblod = !editCaptionsDetail?.fontBold;
    editCaptionsDetail.fontBold = fontblod;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      fontBold: fontblod,
    }));
  };

  const handleToggleFontItalic = () => {
    const fontitalic = !editCaptionsDetail?.fontItalic;
    editCaptionsDetail.fontItalic = fontitalic;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      fontItalic: fontitalic,
    }));
  };

  const handleChangeOutlineSize = (val) => {
    editCaptionsDetail.outlineSize = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      outlineSize: val,
    }));
  };

  const handleChangeShadowBlur = (val) => {
    editCaptionsDetail.shadowBlur = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      shadowBlur: val,
    }));
  };

  const handleChangeShadowX = (val) => {
    editCaptionsDetail.shadowX = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      shadowX: val,
    }));
  };

  const handleChangeShadowY = (val) => {
    editCaptionsDetail.shadowY = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      shadowY: val,
    }));
  };

  const handleChangeRectRadius = (val) => {
    editCaptionsDetail.rectRadius = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      rectRadius: val,
    }));
  };

  const handleChangePaddingtb = (val) => {
    editCaptionsDetail.paddingtb = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      paddingtb: val,
    }));
  };

  const handleChangePaddinglr = (val) => {
    editCaptionsDetail.paddinglr = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      paddinglr: val,
    }));
  };

  // 统一提交修改
  const editSubtitleSubmit = async (val) => {
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    const index = projectDetail.diySubtitles.findIndex((item) => item.type === 1);
    if (index !== -1) {
      projectDetail.diySubtitles[index] = val;
    } else {
      projectDetail.diySubtitles.push(val);
    }
    setProjectDetail({ ...projectDetail });
    setCaptionsItem(val);
    let diySubtitles = [];
    if (subtitleShow === 3) {
      newcaptionsItem.type = 1;
      val.type = 0;
      diySubtitles = [newcaptionsItem, val];
    } else {
      val.type = 0;
      diySubtitles = [val];
    }

    try {
      const res = projectController.diySubtitle({
        projectId: projectItem.id,
        body: {
          sessionId,
          diySubtitles,
        },
      });
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      {/* 字幕样式设置区域 */}
      <div className="subtitle_style original_subtitle_style">
        {/* 字体选择 */}
        <div
          className="select_family original_select_family"
          onClick={() => {
            setShowSelectFamily(!showSelectFamily);
          }}>
          <div className="select_value">
            <div className="text">{useFontFamily?.subtitleName}</div>
            <Icon name={showSelectFamily ? 'icon-arrow-left' : 'icon-arrow-down'} />
          </div>
          <div className="select_list" style={{ display: showSelectFamily ? 'block' : 'none' }}>
            {famylyList.map((item, index) => (
              <div key={index} className={`family_item`}>
                <img
                  src={item.fontMenuUrl}
                  alt=""
                  onClick={() => {
                    handleChangeFamily(item);
                  }}
                />
                {item.fontFamilyUrl === editCaptionsDetail?.fontFamilyUrl && (
                  <img src={select} className="select-icon" />
                )}
              </div>
            ))}
          </div>
        </div>

        {/* 字体大小选择 */}
        <div
          className="select_fontsize original_select_fontsize"
          onClick={() => {
            setShowSelectFontsize(!showSelectFontsize);
          }}>
          <div className="select_value">
            <div className="text">{useFontSize}px</div>
            <Icon name="icon-arrow-down" />
          </div>
          <div className="select_list" style={{ display: showSelectFontsize ? 'block' : 'none' }}>
            {fontSizeList?.map((item, index) => (
              <div
                key={index}
                className={`fontsize_item ${item.value === editCaptionsDetail?.fontSize && 'active_fontsize_item'}`}
                onClick={() => {
                  handleChangeFontSize(item);
                }}>
                {item.value}px
              </div>
            ))}
          </div>
        </div>
        {/* 字体样式(粗体/斜体)切换 */}

        <div className={`subtitle_font_style`}>
          <Icon
            name="icon-bold"
            className={`icon ${editCaptionsDetail?.fontBold && 'active'}`}
            onClick={handleToggleFontBold}
          />
        </div>
        <div className={`subtitle_font_style`}>
          <Icon
            name="icon-italics"
            className={`icon ${editCaptionsDetail?.fontItalic && 'active'}`}
            onClick={handleToggleFontItalic}
          />
        </div>
        {/* 颜色选择器 */}
        <ColorItem
          subtitleColorFlag={subtitleColorFlag}
          setSubtitleColorFlag={setSubtitleColorFlag}
          color={editCaptionsDetail?.fontColor}
          setColor={handleChangeSubtitleColor}
          opacity={editCaptionsDetail?.fontOpacity}
          setOpacity={handleChangeSubtitleOpacity}
        />
      </div>

      {/* 文字轮廓设置区域 */}
      <div className="change_text_style_box">
        <div className="toggle_box">
          <span>{t('As_Edit_StyleoptionTextoutline')}</span>
          <Switch
            className="toggle_checkbox"
            checked={editCaptionsDetail.showOutline ?? false}
            onCheckedChange={handleChangeTextOutline}
          />
        </div>
        {editCaptionsDetail?.showOutline && (
          <div className="text_outline_box">
            <div className="text_outline_main">
              <div className="text_outline_range">
                <div className="icon_text_box">
                  <Icon name="icon-border" className="icon" />
                  <span className="text">{t('As_Edit_BorderAdjust')}</span>
                </div>

                <div className="range_box">
                  <CustomRange
                    value={editCaptionsDetail?.outlineSize}
                    min={0}
                    max={30}
                    onChange={(val) => {
                      handleChangeOutlineSize(val);
                    }}
                  />
                </div>
              </div>
              <div>
                <ColorItem
                  subtitleColorFlag={borderColorFlag}
                  setSubtitleColorFlag={setBorderColorFlag}
                  color={editCaptionsDetail?.outlineColor}
                  setColor={handleChangeBorderColor}
                  opacity={editCaptionsDetail?.outlineOpacity}
                  setOpacity={handleChangeBorderOpacity}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* 文字阴影设置区域 */}
      <div className="change_text_style_box">
        <div className="toggle_box">
          <span>{t('As_Edit_Styleoption3')}</span>
          <Switch
            className="toggle_checkbox"
            checked={editCaptionsDetail.showShadow ?? false}
            onCheckedChange={handleChangeTextShadow}
          />
        </div>
        {editCaptionsDetail?.showShadow && (
          <div className="text_outline_box">
            <div className="text_outline_main">
              <div className="text_outline_range">
                <div className="icon_text_box">
                  <Icon name="icon-blur" className="icon" />
                  <span className="text">{t('As_Edit_BlurAdjust')}</span>
                </div>
                <div className="range_box">
                  <CustomRange
                    value={editCaptionsDetail?.shadowBlur}
                    min={0}
                    max={50}
                    onChange={(val) => {
                      handleChangeShadowBlur(val);
                    }}
                  />
                </div>
              </div>
              <div>
                <ColorItem
                  subtitleColorFlag={ShadowColorFlag}
                  setSubtitleColorFlag={setShadowColorFlag}
                  color={editCaptionsDetail?.shadowColor}
                  setColor={handleChangeShadowColor}
                  opacity={editCaptionsDetail?.shadowOpacity}
                  setOpacity={handleChangeShadowOpacity}
                />
              </div>
            </div>
            <div className="range_btm_box">
              <div className="range_item">
                <span className="title">X</span>
                <div className="range_box">
                  <CustomRange
                    value={editCaptionsDetail?.shadowX}
                    min={-100}
                    max={100}
                    canNegative={true}
                    iptw={40}
                    onChange={(val) => {
                      handleChangeShadowX(val);
                    }}
                  />
                </div>
              </div>
              <div className="range_item">
                <span className="title">Y</span>
                <div className="range_box">
                  <CustomRange
                    value={editCaptionsDetail?.shadowY || 0}
                    min={-100}
                    max={100}
                    canNegative={true}
                    iptw={40}
                    onChange={(val) => {
                      handleChangeShadowY(val);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* 背景设置区域 */}
      <div className="change_text_style_box">
        <div className="toggle_box">
          <span>{t('As_Edit_Styleoption4')}</span>
          <Switch
            className="toggle_checkbox"
            checked={editCaptionsDetail.showBgColor ?? false}
            onCheckedChange={handleChangeBackground}
          />
        </div>
        {editCaptionsDetail?.showBgColor && (
          <div className="text_outline_box">
            <div className="text_outline_main">
              <div className="text_outline_range">
                <div className="icon_text_box">
                  <Icon name="icon-radius" className="icon" />
                  <span className="text">{t('As_Edit_RadiusAdjust')}</span>
                </div>
                <div className="range_box">
                  <CustomRange
                    value={editCaptionsDetail?.rectRadius}
                    min={0}
                    max={200}
                    onChange={(val) => {
                      handleChangeRectRadius(val);
                    }}
                  />
                </div>
              </div>
              <div>
                <ColorItem
                  subtitleColorFlag={backgroundColorFlag}
                  setSubtitleColorFlag={setBackgroundColorFlag}
                  color={editCaptionsDetail?.rectBgColor}
                  setColor={handleChangeBackgroundColor}
                  opacity={editCaptionsDetail?.rectBgOpacity}
                  setOpacity={handleChangeBackgroundOpacity}
                />
              </div>
            </div>
            <div className="range_btm_box">
              <div className="range_item">
                <span className="title">
                  <Icon name="icon-padding-y" />
                </span>
                <div className="range_box">
                  <CustomRange
                    value={editCaptionsDetail?.paddingtb}
                    min={0}
                    max={100}
                    canNegative={true}
                    iptw={40}
                    onChange={(val) => {
                      handleChangePaddingtb(val);
                    }}
                  />
                </div>
              </div>
              <div className="range_item">
                <span className="title">
                  <Icon name="icon-padding-x" />
                </span>
                <div className="range_box">
                  <CustomRange
                    value={editCaptionsDetail?.paddinglr || 0}
                    min={0}
                    max={100}
                    canNegative={true}
                    iptw={40}
                    onChange={(val) => {
                      handleChangePaddinglr(val);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

function BilingualStyle() {
  const { t } = useTranslation();
  // 从EditContext获取setShowEditCaptions方法
  const {
    sessionId,
    setNewCaptionsItem,
    captionsItem,
    presetData,
    newcaptionsItem,
    subtitleShow,
    projectDetail,
    setProjectDetail,
    fontSizeBox,
    doubleFontSizeBox,
    selectedAspectRatio,
    setDoubleFontSizeBox,
    setFontSizeBox,
  } = useContext(EditContext);

  // 字幕编辑详情状态
  const [editCaptionsDetail, setEditCaptionsDetail] = useState({});
  useEffect(() => {
    setEditCaptionsDetail({ ...newcaptionsItem });
  }, [newcaptionsItem]);

  // 颜色选择器显示状态
  const [subtitleColorFlag, setSubtitleColorFlag] = useState(false);
  const [borderColorFlag, setBorderColorFlag] = useState(false);
  const [ShadowColorFlag, setShadowColorFlag] = useState(false);
  const [backgroundColorFlag, setBackgroundColorFlag] = useState(false);

  const [showSelectFamily, setShowSelectFamily] = useState(false);
  const [showSelectFontsize, setShowSelectFontsize] = useState(false);

  const [useFontFamily, setUseFontFamily] = useState({});
  const [useFontSize, setUseFontSize] = useState(0);

  // 字体列表

  const [famylyList, setFamilyList] = useState([]);

  useEffect(() => {
    if (useFontFamily?.fontFamilyUrl) {
      const styleSheet = document.createElement('style');
      styleSheet.textContent = `
          @font-face {
            font-family: 'bilingualselectdiyfamily';
            src: url('${useFontFamily.fontFamilyUrl}') format('truetype');
          }
        `;
      document.head.appendChild(styleSheet);
      return () => {
        document.head.removeChild(styleSheet);
      };
    }
  }, [useFontFamily]);
  useEffect(() => {
    setFamilyList(presetData?.subtitleMenu);
  }, [presetData?.subtitleMenu]);
  useEffect(() => {
    const font = famylyList.filter(
      (item) => item.fontFamilyUrl === editCaptionsDetail?.fontFamilyUrl,
    )[0];
    setUseFontFamily(font);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editCaptionsDetail?.fontFamilyUrl]);
  useEffect(() => {
    let size = 0;
    if (selectedAspectRatio === 0) {
      size = subtitleShow === 3 ? doubleFontSizeBox.translateFontSize169 : fontSizeBox?.fontSize169;
    }
    if (selectedAspectRatio === 1) {
      size = subtitleShow === 3 ? doubleFontSizeBox.translateFontSize11 : fontSizeBox?.fontSize11;
    }
    if (selectedAspectRatio === 2) {
      size = subtitleShow === 3 ? doubleFontSizeBox.translateFontSize916 : fontSizeBox?.fontSize916;
    }
    if (selectedAspectRatio === 3) {
      size = subtitleShow === 3 ? doubleFontSizeBox.translateFontSizeCtm : fontSizeBox?.fontSizeCtm;
    }
    setUseFontSize(size);
    // setEditCaptionsDetail((prve) => ({
    //   ...prve,
    //   fontSize: size,
    // }));
  }, [fontSizeBox, selectedAspectRatio, subtitleShow]);
  // 全局点击事件监听
  useEffect(() => {
    const handleClickOutside = (event) => {
      // 点击字体选择框以外的区域时关闭下拉列表
      const selectFamily = document.querySelector('.bilingual_select_family');
      if (selectFamily && !selectFamily.contains(event.target)) {
        setShowSelectFamily(false);
      }
      const selectFontsize = document.querySelector('.bilingual_select_fontsize');
      if (selectFontsize && !selectFontsize.contains(event.target)) {
        setShowSelectFontsize(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // 文字轮廓开关处理函数
  const handleChangeTextOutline = (e) => {
    editCaptionsDetail.showOutline = e;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      showOutline: e,
    }));
  };

  // 文字阴影开关处理函数
  const handleChangeTextShadow = (e) => {
    editCaptionsDetail.showShadow = e;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      showShadow: e,
    }));
  };

  // 背景开关处理函数
  const handleChangeBackground = (e) => {
    editCaptionsDetail.showBgColor = e;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      showBgColor: e,
    }));
  };

  // 字幕颜色相关处理函数
  const handleChangeSubtitleColor = (val) => {
    editCaptionsDetail.fontColor = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      fontColor: val,
    }));
  };
  const handleChangeSubtitleOpacity = (val) => {
    editCaptionsDetail.fontOpacity = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      fontOpacity: val,
    }));
  };

  // 边框颜色相关处理函数
  const handleChangeBorderColor = (val) => {
    editCaptionsDetail.outlineColor = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      outlineColor: val,
    }));
  };
  const handleChangeBorderOpacity = (val) => {
    editCaptionsDetail.outlineOpacity = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      outlineOpacity: val,
    }));
  };

  // 阴影颜色相关处理函数
  const handleChangeShadowColor = (val) => {
    editCaptionsDetail.shadowColor = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      shadowColor: val,
    }));
  };
  const handleChangeShadowOpacity = (val) => {
    editCaptionsDetail.shadowOpacity = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      shadowOpacity: val,
    }));
  };

  // 背景颜色相关处理函数
  const handleChangeBackgroundColor = (val) => {
    editCaptionsDetail.rectBgColor = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      rectBgColor: val,
    }));
  };
  const handleChangeBackgroundOpacity = (val) => {
    editCaptionsDetail.rectBgOpacity = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      rectBgOpacity: val,
    }));
  };

  const handleChangeFamily = (val) => {
    editCaptionsDetail.fontFamilyUrl = val.fontFamilyUrl;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      fontFamilyUrl: val.fontFamilyUrl,
    }));
  };
  const handleChangeFontSize = (val) => {
    editCaptionsDetail.fontSize = val.value;
    setEditCaptionsDetail((prve) => ({
      ...prve,
      fontSize: val.value,
    }));
    setUseFontSize(val.value);
    let obj = {};
    if (subtitleShow === 3) {
      obj = {
        doubleFontSize: {
          translateFontSize: val.value,
        },
      };
      if (selectedAspectRatio === 0) {
        setDoubleFontSizeBox((prve) => ({
          ...prve,
          translateFontSize169: val.value,
        }));
      }
      if (selectedAspectRatio === 1) {
        setDoubleFontSizeBox((prve) => ({
          ...prve,
          translateFontSize11: val.value,
        }));
      }
      if (selectedAspectRatio === 2) {
        setDoubleFontSizeBox((prve) => ({
          ...prve,
          translateFontSize916: val.value,
        }));
      }
      if (selectedAspectRatio === 3) {
        setDoubleFontSizeBox((prve) => ({
          ...prve,
          translateFontSizeCtm: val.value,
        }));
      }
    } else {
      obj = {
        fontSize: {
          originalFontSize: val.value,
        },
      };
      if (selectedAspectRatio === 0) {
        setFontSizeBox((prve) => ({
          ...prve,
          fontSize169: val.value,
        }));
      }
      if (selectedAspectRatio === 1) {
        setFontSizeBox((prve) => ({
          ...prve,
          fontSize11: val.value,
        }));
      }
      if (selectedAspectRatio === 2) {
        setFontSizeBox((prve) => ({
          ...prve,
          fontSize916: val.value,
        }));
      }
      if (selectedAspectRatio === 3) {
        setFontSizeBox((prve) => ({
          ...prve,
          fontSizeCtm: val.value,
        }));
      }
    }
    setNewCaptionsItem(editCaptionsDetail);
    try {
      const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
      projectController.updateFontSize({
        projectId: projectItem.id,
        body: {
          sessionId,
          ...obj,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleToggleFontBold = () => {
    const fontblod = !editCaptionsDetail?.fontBold;
    editCaptionsDetail.fontBold = fontblod;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      fontBold: fontblod,
    }));
  };

  const handleToggleFontItalic = () => {
    const fontitalic = !editCaptionsDetail?.fontItalic;
    editCaptionsDetail.fontItalic = fontitalic;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      fontItalic: fontitalic,
    }));
  };

  const handleChangeOutlineSize = (val) => {
    editCaptionsDetail.outlineSize = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      outlineSize: val,
    }));
  };

  const handleChangeShadowBlur = (val) => {
    editCaptionsDetail.shadowBlur = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      shadowBlur: val,
    }));
  };

  const handleChangeShadowX = (val) => {
    editCaptionsDetail.shadowX = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      shadowX: val,
    }));
  };

  const handleChangeShadowY = (val) => {
    editCaptionsDetail.shadowY = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      shadowY: val,
    }));
  };

  const handleChangeRectRadius = (val) => {
    editCaptionsDetail.rectRadius = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      rectRadius: val,
    }));
  };

  const handleChangePaddingtb = (val) => {
    editCaptionsDetail.paddingtb = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      paddingtb: val,
    }));
  };

  const handleChangePaddinglr = (val) => {
    editCaptionsDetail.paddinglr = val;
    editSubtitleSubmit(editCaptionsDetail);
    setEditCaptionsDetail((prve) => ({
      ...prve,
      paddinglr: val,
    }));
  };

  // 统一提交修改
  const editSubtitleSubmit = async (val) => {
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    const index = projectDetail.diySubtitles.findIndex((item) => item.type === 0);
    if (index !== -1) {
      projectDetail.diySubtitles[index] = val;
    } else {
      projectDetail.diySubtitles.push(val);
    }
    setProjectDetail({ ...projectDetail });
    setNewCaptionsItem(val);
    let diySubtitles = [];
    if (subtitleShow === 3) {
      captionsItem.type = 0;
      val.type = 1;
      diySubtitles = [captionsItem, val];
    } else {
      val.type = 1;
      diySubtitles = [val];
    }
    try {
      const res = projectController.diySubtitle({
        projectId: projectItem.id,
        body: {
          sessionId,
          diySubtitles,
        },
      });
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      {/* 字幕样式设置区域 */}
      <div className="subtitle_style bilingual_subtitle_style">
        {/* 字体选择 */}
        <div
          className="select_family bilingual_select_family"
          onClick={() => {
            setShowSelectFamily(!showSelectFamily);
          }}>
          <div className="select_value">
            <div className="text">{useFontFamily?.subtitleName}</div>
            <Icon name={showSelectFamily ? 'icon-arrow-left' : 'icon-arrow-down'} />
          </div>
          <div className="select_list" style={{ display: showSelectFamily ? 'block' : 'none' }}>
            {famylyList.map((item, index) => (
              <div key={index} className={`family_item `}>
                <img
                  src={item.fontMenuUrl}
                  alt=""
                  onClick={() => {
                    handleChangeFamily(item);
                  }}
                />
                {item.fontFamilyUrl === editCaptionsDetail?.fontFamilyUrl && (
                  <img src={select} className="select-icon" />
                )}
              </div>
            ))}
          </div>
        </div>

        {/* 字体大小选择 */}
        <div
          className="select_fontsize bilingual_select_fontsize"
          onClick={() => {
            setShowSelectFontsize(!showSelectFontsize);
          }}>
          <div className="select_value">
            <div className="text">{useFontSize}px</div>
            <Icon name="icon-arrow-down" />
          </div>
          <div className="select_list" style={{ display: showSelectFontsize ? 'block' : 'none' }}>
            {fontSizeList?.map((item, index) => (
              <div
                key={index}
                className={`fontsize_item ${item.value === editCaptionsDetail?.fontSize && 'active_fontsize_item'}`}
                onClick={() => {
                  handleChangeFontSize(item);
                }}>
                {item.value}px
              </div>
            ))}
          </div>
        </div>
        {/* 字体样式(粗体/斜体)切换 */}
        <div className={`subtitle_font_style`}>
          <Icon
            name="icon-bold"
            className={`icon ${editCaptionsDetail?.fontBold && 'active'}`}
            onClick={handleToggleFontBold}
          />
        </div>
        <div className={`subtitle_font_style`}>
          <Icon
            name="icon-italics"
            className={`icon ${editCaptionsDetail?.fontItalic && 'active'}`}
            onClick={handleToggleFontItalic}
          />
        </div>
        {/* 颜色选择器 */}
        <ColorItem
          subtitleColorFlag={subtitleColorFlag}
          setSubtitleColorFlag={setSubtitleColorFlag}
          color={editCaptionsDetail?.fontColor}
          setColor={handleChangeSubtitleColor}
          opacity={editCaptionsDetail?.fontOpacity}
          setOpacity={handleChangeSubtitleOpacity}
        />
      </div>

      {/* 文字轮廓设置区域 */}
      <div className="change_text_style_box">
        <div className="toggle_box">
          <span>{t('As_Edit_StyleoptionTextoutline')}</span>
          <Switch
            className="toggle_checkbox"
            checked={editCaptionsDetail.showOutline ?? false}
            onCheckedChange={handleChangeTextOutline}
          />
        </div>
        {editCaptionsDetail?.showOutline && (
          <div className="text_outline_box">
            <div className="text_outline_main">
              <div className="text_outline_range">
                <div className="icon_text_box">
                  <Icon name="icon-border" className="icon" />
                  <span className="text">{t('As_Edit_BorderAdjust')}</span>
                </div>

                <div className="range_box">
                  <CustomRange
                    value={editCaptionsDetail?.outlineSize}
                    min={0}
                    max={30}
                    onChange={(val) => {
                      handleChangeOutlineSize(val);
                    }}
                  />
                </div>
              </div>
              <div>
                <ColorItem
                  subtitleColorFlag={borderColorFlag}
                  setSubtitleColorFlag={setBorderColorFlag}
                  color={editCaptionsDetail?.outlineColor}
                  setColor={handleChangeBorderColor}
                  opacity={editCaptionsDetail?.outlineOpacity}
                  setOpacity={handleChangeBorderOpacity}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* 文字阴影设置区域 */}
      <div className="change_text_style_box">
        <div className="toggle_box">
          <span>{t('As_Edit_Styleoption3')}</span>
          <Switch
            className="toggle_checkbox"
            checked={editCaptionsDetail.showShadow ?? false}
            onCheckedChange={handleChangeTextShadow}
          />
        </div>
        {editCaptionsDetail?.showShadow && (
          <div className="text_outline_box">
            <div className="text_outline_main">
              <div className="text_outline_range">
                <div className="icon_text_box">
                  <Icon name="icon-blur" className="icon" />
                  <span className="text">{t('As_Edit_BlurAdjust')}</span>
                </div>
                <div className="range_box">
                  <CustomRange
                    value={editCaptionsDetail?.shadowBlur}
                    min={0}
                    max={50}
                    onChange={(val) => {
                      handleChangeShadowBlur(val);
                    }}
                  />
                </div>
              </div>
              <div>
                <ColorItem
                  subtitleColorFlag={ShadowColorFlag}
                  setSubtitleColorFlag={setShadowColorFlag}
                  color={editCaptionsDetail?.shadowColor}
                  setColor={handleChangeShadowColor}
                  opacity={editCaptionsDetail?.shadowOpacity}
                  setOpacity={handleChangeShadowOpacity}
                />
              </div>
            </div>
            <div className="range_btm_box">
              <div className="range_item">
                <span className="title">X</span>
                <div className="range_box">
                  <CustomRange
                    value={editCaptionsDetail?.shadowX}
                    min={-100}
                    max={100}
                    canNegative={true}
                    iptw={40}
                    onChange={(val) => {
                      handleChangeShadowX(val);
                    }}
                  />
                </div>
              </div>
              <div className="range_item">
                <span className="title">Y</span>
                <div className="range_box">
                  <CustomRange
                    value={editCaptionsDetail?.shadowY || 0}
                    min={-100}
                    max={100}
                    canNegative={true}
                    iptw={40}
                    onChange={(val) => {
                      handleChangeShadowY(val);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* 背景设置区域 */}
      <div className="change_text_style_box">
        <div className="toggle_box">
          <span>{t('As_Edit_Styleoption4')}</span>
          <Switch
            className="toggle_checkbox"
            checked={editCaptionsDetail.showBgColor ?? false}
            onCheckedChange={handleChangeBackground}
          />
        </div>
        {editCaptionsDetail?.showBgColor && (
          <div className="text_outline_box">
            <div className="text_outline_main">
              <div className="text_outline_range">
                <div className="icon_text_box">
                  <Icon name="icon-radius" className="icon" />
                  <span className="text">{t('As_Edit_RadiusAdjust')}</span>
                </div>
                <div className="range_box">
                  <CustomRange
                    value={editCaptionsDetail?.rectRadius}
                    min={0}
                    max={200}
                    onChange={(val) => {
                      handleChangeRectRadius(val);
                    }}
                  />
                </div>
              </div>
              <div>
                <ColorItem
                  subtitleColorFlag={backgroundColorFlag}
                  setSubtitleColorFlag={setBackgroundColorFlag}
                  color={editCaptionsDetail?.rectBgColor}
                  setColor={handleChangeBackgroundColor}
                  opacity={editCaptionsDetail?.rectBgOpacity}
                  setOpacity={handleChangeBackgroundOpacity}
                />
              </div>
            </div>
            <div className="range_btm_box">
              <div className="range_item">
                <span className="title">
                  <Icon name="icon-padding-y" />
                </span>
                <div className="range_box">
                  <CustomRange
                    value={editCaptionsDetail?.paddingtb}
                    min={0}
                    max={100}
                    canNegative={true}
                    iptw={40}
                    onChange={(val) => {
                      handleChangePaddingtb(val);
                    }}
                  />
                </div>
              </div>
              <div className="range_item">
                <span className="title">
                  <Icon name="icon-padding-x" />
                </span>
                <div className="range_box">
                  <CustomRange
                    value={editCaptionsDetail?.paddinglr || 0}
                    min={0}
                    max={100}
                    canNegative={true}
                    iptw={40}
                    onChange={(val) => {
                      handleChangePaddinglr(val);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
// 颜色选择器组件
function ColorItem({
  color,
  setColor,
  opacity,
  setOpacity,
  subtitleColorFlag,
  setSubtitleColorFlag,
  className,
}) {
  const [inputColorValue, setInputColorValue] = useState('');
  useEffect(() => {
    setInputColorValue(color);
  }, [color]);
  const isValidHexColor = (color) => {
    const hexColorPattern = /^#[0-9A-Fa-f]{6}$/; // 只判断六位的颜色
    return hexColorPattern.test(color);
  };
  const handleChangeColor = (e) => {
    setInputColorValue(e.target.value);
  };
  const handleBlurColor = () => {
    if (isValidHexColor(inputColorValue)) {
      setColor(inputColorValue);
    } else {
      setInputColorValue(color);
    }
  };
  return (
    <div className={`color_select_box ${className}`}>
      <div className={`color_select select_color_btn`}>
        <div
          className="color_picker"
          onClick={() => {
            setSubtitleColorFlag(!subtitleColorFlag);
          }}>
          <div className="color_preview_left" style={{ background: color }}></div>
          <div
            className="color_preview_right"
            style={{ background: color, opacity: opacity + '%' }}></div>
          <Icon name="icon-colour" className="icon_colour" />
        </div>
        <input
          className="input_color"
          type="text"
          value={inputColorValue || ''}
          onBlur={handleBlurColor}
          onChange={handleChangeColor}
        />
      </div>
      {subtitleColorFlag && (
        <div className="color_select_tool">
          <ColorTool
            colorValue={color}
            opacityValue={opacity}
            setOpacity={setOpacity}
            onColorChange={setColor}
            onShow={setSubtitleColorFlag}
          />
        </div>
      )}
    </div>
  );
}
